import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="action-message"
export default class extends Controller {
  connect() {
    // 5秒後にメッセージを非表示にする
    this.timeoutId = setTimeout(() => this.element.hidden = true, 5000)
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }
}
